export class FrameLabel {
    public readonly frame: number;
    public readonly name: string;
    constructor(name: string, frame: number) {
        this.name = name;
        this.frame = frame;
    }
}
